import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'


const _hoisted_1 = { class: "link" }
const _hoisted_2 = { class: "truncate inline-block space-x-1 text-sm w-full" }
const _hoisted_3 = { class: "my-8" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-3 sm:grid-cols-2 gap-6" }
const _hoisted_5 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "picture icon"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_11 = {
  key: 1,
  controls: "",
  class: "object-cover w-96 h-75 rounded-md"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_1,
  alt: "video icon"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { // vue
		inject,
		onMounted,
		ref,
	} from 'vue'

	
	const __default__ = { name: 'InstructionDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		openToTab: {
			type: Number,
			default: 0
		},
		instruction: {
			type: Object,
			default: () => {return {}}
		},
		previous: {
			type: Object,
			default: () => {return {}}
		},
		showDetails: {
			type: Function, 
			default: () => {return}
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()

	const {t} = useI18n()

	const loading = ref(true)
	const s3: any = inject('s3')
	const signedUrlPhoto = ref('')
	const signedUrlVideo = ref('')

	onMounted(async () => {
		try { // fetching image and video from s3
			loading.value = true
			const photoS3 = props.instruction?.['jobs_variations_roles__INSTRUCTIONS_JOIN_JOBS_jobsVariationsRoleID::s3JSONPicture'] ||
				props.instruction?.['jobs_variations_roles__instructions_join_jobs__INSTRUCTIONS_JOIN__instructionsJoinID::s3JSONPictureRole']
			const photoS3Json = JSON.parse(photoS3 || "{}")
			const photoKey = photoS3Json?.s3FilePathShortRaw
			
			const videoS3 = props.instruction?.['jobs_variations_roles__INSTRUCTIONS_JOIN_JOBS_jobsVariationsRoleID::s3JSONVideo'] ||
				props.instruction?.['jobs_variations_roles__instructions_join_jobs__INSTRUCTIONS_JOIN__instructionsJoinID::s3JSONVideoRole']
			const videoS3Json = JSON.parse(videoS3 || "{}")
			const videoKey = videoS3Json?.s3FilePathShortRaw
			
			if(photoKey) {
				let params = {
					Bucket: process.env.VUE_APP_S3_BUCKET,
					Key: photoKey
				}
	
				s3.getSignedUrlPromise('getObject', params).then(
					function (url: string) {
						signedUrlPhoto.value = url
					}, 
					function (err: Error) { 
						throw err
					}
				)
			}
			if(videoKey) {
				let params = {
					Bucket: process.env.VUE_APP_S3_BUCKET,
					Key: videoKey
				}
	
				s3.getSignedUrlPromise('getObject', params).then(
					function (url: string) {
						signedUrlVideo.value = url
					}, 
					function (err: Error) { 
						throw err
					}
				)
			}
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}
	})


return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.showDetails(__props.previous, 'varRolesInstructionsList', null, null))),
        class: "flex justify-start items-center cursor-pointer"
      }, [
        _createVNode(_component_ArrowLeftIcon, { class: "w-5 h-5" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.returnToInstructions")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_data_display, {
        label: _unref(_localesStore).getLabel('181'),
        value: __props.instruction['jobs_variations_roles__INSTRUCTIONS_JOIN_JOBS_jobsVariationsRoleID::instructions_display_edit']
      }, null, 8, ["label", "value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createVNode(_component_data_display, {
          label: _unref(_localesStore).getLabel('293')
        }, {
          custom: _withCtx(() => [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : (signedUrlPhoto.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "object-cover w-96 h-75 rounded-md",
                    src: signedUrlPhoto.value
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_data_display, {
          label: _unref(_localesStore).getLabel('294')
        }, {
          custom: _withCtx(() => [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10))
              : (signedUrlVideo.value)
                ? (_openBlock(), _createElementBlock("video", _hoisted_11, [
                    _createElementVNode("source", {
                      type: "video/mp4",
                      src: signedUrlVideo.value
                    }, null, 8, _hoisted_12)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ])
  ], 64))
}
}

})